import PublicLayout from "@/components/PublicLayout";
import { Link } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/forgot-password", { email: email.trim().toLowerCase() });
      setSent(true);
      toast.success("If the email exists, a reset link has been sent.");
    } catch {
      toast.error("Failed to send reset email");
    }
  };

  return (
    <PublicLayout>
      <section className="py-16 gradient-radial-blue">
        <div className="max-w-md mx-auto px-4">
          <div className="rounded-2xl border border-slate-200 bg-white p-8 shadow-sm">
            <div className="section-label">Reset Password</div>
            <h1 className="mt-2 font-display font-bold text-3xl text-[#0A192F]">Forgot your password?</h1>
            <p className="text-sm text-slate-600 mt-1">We&apos;ll send a secure reset link to your email.</p>
            {sent ? (
              <div className="mt-6 p-4 rounded-md bg-emerald-50 border border-emerald-200 text-sm text-emerald-800" data-testid="forgot-sent">
                Check your inbox for a reset link. If you don&apos;t see it within a few minutes, check the spam folder.
              </div>
            ) : (
              <form onSubmit={submit} className="mt-6 space-y-4">
                <div>
                  <Label>Email</Label>
                  <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" />
                </div>
                <Button type="submit" className="w-full bg-[#1E3A8A] hover:bg-[#1E40AF] h-11" data-testid="forgot-submit-btn">
                  Send Reset Link
                </Button>
              </form>
            )}
            <div className="mt-5 text-center text-sm text-slate-600">
              <Link to="/login" className="text-[#1E3A8A] font-medium hover:underline">← Back to sign in</Link>
            </div>
          </div>
        </div>
      </section>
    </PublicLayout>
  );
}
